import React from 'react'

import clsx from 'clsx'

import Grid from 'components/Grid'
import { FixedImage } from 'components/NextImage'
import { useEventContext } from 'context/EventContext'

import TextBase from '../TextBase'
import MoreIntegrations from './components/MoreIntegrations'

import classes from './Integrations.module.scss'

/** @type {import("./types").default} */
const Integrations = ({ title, htmlText: textBase, className, bxListing }) => {
  const { addEvent } = useEventContext()

  const mainIntegrations = (bxListing?.integrations && bxListing.integrations.nodes) || []
  const extraIntegrations = (bxListing?.integrations && bxListing.integrations.extraIntegrations) || []

  return (
    <section className={clsx('Integrations', className)}>
      <TextBase title={title} />
      <TextBase htmlText={textBase} />
      <Grid container className={classes.integrationsContainer}>
        {mainIntegrations.map(({ name, htmlText, logoUrl, url }) => (
          <div key={`integration_${name}`}>
            <div className={classes.integration}>
              <FixedImage src={logoUrl} alt={name} height={32} width={32} />
              <a
                href={url}
                className={classes.link}
                {...addEvent({
                  engagementComponent: 'product_integrations',
                  engagementDestination: 'go-to_product_details',
                  engagementDetails: 'text-link_product-name',
                  name: 'engagement_product_click',
                })}
              >
                {name}
              </a>
            </div>
            <TextBase htmlText={htmlText} className={classes.description} />
            <div className={classes.divider} />
          </div>
        ))}
        <MoreIntegrations restIntegrations={extraIntegrations} />
      </Grid>
    </section>
  )
}

export default Integrations
